import {DEVICE_SETTINGS_POPUP_VALUES} from '@/consts/aem/aemDeviceSettingsPopupValueTypes';
import {LED_MODE_TYPES} from '@/consts/uam/ledModeTypes';

export const POPUP_VALUE_TO_LED_MODE = {
    [DEVICE_SETTINGS_POPUP_VALUES.ILLUMINATION_MODE_LOW]: LED_MODE_TYPES.NIGHT_MODE,
    [DEVICE_SETTINGS_POPUP_VALUES.ILLUMINATION_MODE_STRONG]: LED_MODE_TYPES.DAY_MODE,
};

export const getPopupValueByIntensity = (popup, intensity) =>
    popup?.groups?.values.find((v) => POPUP_VALUE_TO_LED_MODE[v.type] === intensity);
